import { validateMetadata } from '../cart';
export default class BaseValidator {
    /**
     *  Validate a specific cart metadata.
     *
     *  ```ts
     *  const cartMetadata = {
     *      item: shop.data.metadata[id],
     *      value: null,
     *      errors: [],
     *  };
     *
     *  const validationOk: string[] | undefined = cart.validateMetadata(cartMetadata);
     *  const validationOk: string[] | undefined = cart.validateMetadata(cartMetadata, false);
     *  ```
     *
     *  When the mutateErrors boolean is not set,
     *  the errors are returned, but not set on the cart metadata instance.
     *
     *  | Error                                    | Reason                              |
     *  | :--------------------------------------- | :---------------------------------- |
     *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
     *
     *  Note: Failed validation will NOT throw an error
     */
    metadata(metadata, mutateErrors = true) {
        const validationErrors = validateMetadata(metadata, mutateErrors);
        return {
            valid: !validationErrors.length,
            message: validationErrors[0] || '',
            errors: validationErrors,
        };
    }
}
//# sourceMappingURL=validation.js.map